export const css = {
    root: 'NtPCTIMb',
    title: 'rIqvIEd-',
    label: 'AJ6teI65',
    actions: 'F50qy-3L',
    ' _key': 'card/pretest'
};
export default css;
